import { HttpEventType, HttpResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { FileService } from 'src/app/services/file/file.service';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';
import { UploadZipService } from 'src/app/services/upload-zip/upload-zip.service';
import { XlsxService } from 'src/app/services/xlsx/xlsx.service';
import { AlertService } from 'src/app/shared/providers/AlertProvider';
import { ExportExcelService } from 'src/app/shared/xlsx-view/export-excel.service';
import { XlsxViewComponent } from 'src/app/shared/xlsx-view/xlsx-view.component';
import { ChannelModel } from '../shared/models/channel';
import { Modules } from '../shared/models/general-model';
import { GapExcelModel, GeographyModel } from '../shared/models/geography';
import { RegionModel } from '../shared/models/region';
import { ChannelProvider } from '../shared/providers/channel.provider';
import { GeographyProvider } from '../shared/providers/geography.provider';
import { AdminDataProvider } from '../shared/providers/master-provider/admin-data.provider';
import { RegionProvider } from '../shared/providers/region.provider';
import { RolesProvider } from '../shared/providers/roles.provider';
import { StateProvider } from '../shared/providers/state.provider';
import { NgxUiLoaderService } from "ngx-ui-loader";
import { Workbook } from 'exceljs';
import { DatePipe } from '@angular/common';
import { GAP_EXCEL } from '../shared/models/mock-data';
import * as fs from "file-saver";
import { async } from '@angular/core/testing';

@Component({
  selector: 'app-gap-analysis',
  templateUrl: './gap-analysis.component.html',
  styleUrls: ['./gap-analysis.component.scss']
})
export class GapAnalysisComponent implements OnInit {
  min: number;
  max: number;
  searchPage = 1;
  options: Array<any> = [];
  errorMsg = "";
  modalRef: BsModalRef;
  message: string;
  progress: number = 0;
  getPaginationCount;
  fileContent;
  formData;
  constructor(
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private fb: FormBuilder,
    private router: Router,
    private modalService: NgbModal,
    public exportExcelService: ExportExcelService,
    public adminDataProvider: AdminDataProvider,
    public regionProviders: RegionProvider,
    public stateProviders: StateProvider,
    public channelProviders: ChannelProvider,
    public geoProviders: GeographyProvider,
    private rolesProvider: RolesProvider,
    public toast: ToastClientService,
    private xlsx: XlsxService,
    public alertService: AlertService,
    private uploadFile: UploadZipService,
    public fileService: FileService,
    public ngxService: NgxUiLoaderService,
    private datePipe: DatePipe
  ) { }
  public headers;
  public columns;
  public save = true;
  public notice = true;
  public month;
  public year;
  public ro_name = [];
  public moduleId;
  public modules: Modules[];
  public userList: any[];
  public excel = [
    {
      outlet_code: "",
    },
  ];

  regions: RegionModel[];
  geography: GeographyModel[];
  channels: ChannelModel[];
  roles: any[];
  cities: any[];
  states: any[];
  uploadFileSubscribe: any;
  type: any;
  totaldata: any;
  gapData : any = []
  gapExcelModel: GapExcelModel = new GapExcelModel;
  startDate : any = "";
  endDate : any = "";
 
  ngOnInit() {
   
  }


  ngDoCheck() {
    this.regions = this.regionProviders.regions;
    this.channels = this.channelProviders.channels;
    this.states = this.stateProviders.state;
  }

  whitelistedUsersList: any[] = [];

  fileName: string = "";
  excelData: any[];
  files: FileList;


  importExcel(event) {
    if (event.target.files.length > 0) {
      this.fileName = event.target.files[0].name;
    }
    this.files = event.target.files;
    this.xlsx.uploadXlsx(event).then((res: any) => {
      this.headers = res.headers;
      this.columns = res.data;
      this.save = false;
      this.notice = false;
      this.excelData = res;
    });
   
      let reader = new FileReader();
      reader.readAsDataURL(event.target.files[0])
      let my = this;
      reader.addEventListener('load', function () {
        my.fileContent = reader.result;
      })
      console.log("selected", this.fileContent)
    
    }


    getGapData(){
      
      if(this.startDate == "" || this.endDate == ""){
         this.toast.Error("Fields are required")
      }else{
        let payload = {
          start_date : this.startDate,
          end_date : this.endDate
         }
         console.log(payload)
         this.apiService.post(this.apiConfig.gapAnalysisReportnew , payload).subscribe((res : any)=>{
           console.log(res)
           this.gapData = res.body.data.gap_file;
         })
      }
    }




  xlsxView(data) {
      // data.apiHeaders = this.brandsListHeaders;
      let modalRef = this.modalService.open(XlsxViewComponent, {
        centered: true,
        backdrop: "static",
        size: "xl",
        scrollable: true,
        windowClass: "ExcelTemplateViewModal",
      });
      modalRef.componentInstance.xlsxDatas = data;
      modalRef.result.then(
        (result) => {
          if (result.length > 0) {
            this.gapExcelModel.gap_input_data = result;
            this.gapExcelModel.gap_upload = 1;
            this.gapExcelModel.gap_file = this.fileContent;
            this.uploadToServer(result);

          }
        },
        (reason) => { }
      );
    }

  uploadMultiData(data) {
      this.enableUploadDiv(data);
    }

  loaderStart() {
      try {
        this.ngxService.start();
      } catch(error) {
        console.log(error);
      }
    }
  loaderDismiss() {
      try {
        // this.loadingCntr.dismiss();
        this.ngxService.stop();
      } catch(error) { }
    }

  enableUploadDiv(data) {
      let payload = {
        month: this.month,
        year: this.year,
        excel_data: data,
      };
      this.uploadFile.changeMessage({
        status: "upload",
        data: payload,
        url: this.apiConfig.createWhitelist,
        module: "User Modules",
        zip: "no",
        excelname: "User Modules Excel",
      });
    }

  onSave() {
    let payload = {
        excel_data: this.columns,
        gap_file: this.formData
      };
      console.log(payload);
      this.xlsxView(this.excelData);
    }
  show: boolean;
    uploadToServer(files: FileList) {
      this.show = true;
      this.loaderStart();
      this.uploadFileSubscribe = this.apiService.post(this.apiConfig.gapAnalysisNew, this.gapExcelModel).subscribe(event => {
        if (event.type === HttpEventType.UploadProgress) {
          this.type = 'success';
          //this.progress =  Math.round(100 * event.loaded / event.total);
          console.log(this.progress);
        } else if (event instanceof HttpResponse) {
          if (event.body.data) {
            // this.uploadedStatus = event.body.data;
            this.exportExcelService.GapAnalysisReponseExcel(event.body.data)
            // this.exportExcelService.GapAnalysisNewUserExcel(event.body.data)
            // this.uploadFile.responseData(this.uploadedStatus);
            this.loaderDismiss();
            this.clearSuccess();
            this.totaldata = event.body.data;
          }
        }
        this.toast.Success("Gap Analysis Success")
      }, err => {
        console.log('err', err);
        this.toast.Error(err.error.data.message);
        this.type = 'danger';
        this.loaderDismiss();
      });
    }

    downloadExcel() {
      debugger
      this.exportExcelService.exportGapAnalysisExcel(this.channels, this.regions, this.states);
    }


    clearSuccess() {
      setTimeout(() => {
        this.alertService.clear(); // stop foreground spinner of the master loader with 'default' taskId
        this.show = false;
      }, 4000);
    }

    ngDestroy() {
      this.totaldata.unSubscribe()
    }
    
//   res = {
//     "success": true,
//     "status": 200,
//     "data": {
//         "gap_file": [
//             {
//                 "file_name": "http://localhost/hubadminapi/web/uploads/outlet_gap_analysis/6232de3e2f394-20220317123742.csv",
//                 "gap_id": 116,
//                 "gap_records": [
//                     {
//                         "outlet_code": "663232",
//                         "csm_number": "7027370123",
//                         "state_code": 1,
//                         "bud4trade_status": "Existing User",
//                         "abinbev_status": "Available",
//                         "gap_analysis_remarks": "Exisitng User, ",
//                         "outlet_gap": "OK",
//                         "csm_gap": "OK",
//                         "state_gap": "OK",
//                         "status": "No Gaps",
//                         "analyzed_date": "2022-03-17 12:37:42.254872"
//                     }
//                 ]
//             },
//             {
//                 "file_name": "http://localhost/hubadminapi/web/uploads/outlet_gap_analysis/6232df0da4156-20220317124109.csv",
//                 "gap_id": 117,
//                 "gap_records": [
//                     {
//                         "outlet_code": "663232",
//                         "csm_number": "7027370123",
//                         "state_code": 1,
//                         "bud4trade_status": "Existing User",
//                         "abinbev_status": "Available",
//                         "gap_analysis_remarks": "Exisitng User, ",
//                         "outlet_gap": "OK",
//                         "csm_gap": "OK",
//                         "state_gap": "OK",
//                         "status": "No Gaps",
//                         "analyzed_date": "2022-03-17 12:41:09.740827"
//                     },
//                     {
//                         "outlet_code": "663211",
//                         "csm_number": "7027370123",
//                         "state_code": 1,
//                         "bud4trade_status": "Existing User",
//                         "abinbev_status": "Available",
//                         "gap_analysis_remarks": "Exisitng User, ",
//                         "outlet_gap": "OK",
//                         "csm_gap": "OK",
//                         "state_gap": "OK",
//                         "status": "No Gaps",
//                         "analyzed_date": "2022-03-17 12:41:09.740827"
//                     }
//                 ]
//             }
//         ]
//     }
// }
uploadedFile(gap_id){
  debugger
  console.log(gap_id)
  let a = document.getElementById(gap_id).click()
}
analysedFile(data){
console.log(data)
this.exportExcelService.GapAnalysisUserReport(data)

}

  }
